import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { DataStateChangeEventArgs, FilterSettingsModel, SearchSettingsModel, TextWrapSettingsModel, ToolbarItems } from '@syncfusion/ej2-grids';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { GeneralService } from 'src/app/service/general.service';
import { ColumnChangeBO } from '../../eligibility270/eligibility270.model';
import { columnWidth } from '../../icd10/icd10.model';
import { EDI271ClientReportBO, GetEDI271ClientBO } from '../client-parent.model';
import { CommonApiService } from 'src/app/commonapiservice';
@Component({
  selector: 'app-eligibility-difference-report',
  templateUrl: './eligibility-difference-report.component.html',
  styleUrls: ['./eligibility-difference-report.component.scss']
})
export class EligibilityDifferenceReportComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  public data: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  ColumnArray: columnWidth[]
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: number = 0;
  arraycol: any = [];
  EDI271Client: EDI271ClientReportBO[];
  public toolbar: ToolbarItems[];
  public searchSettings: SearchSettingsModel;
  public wrapSettings: TextWrapSettingsModel;
  @ViewChild('grid') public grid: GridComponent;
  @Input() DataFromList: GetEDI271ClientBO = new GetEDI271ClientBO();
  @Input() ClientId
  @Output() Event = new EventEmitter<GetEDI271ClientBO>();
  filterOptions: FilterSettingsModel;
  initialPage: object;
  height: string = "200px";
  datalength: number = 0
  public formatOptions: object;
  eligiblitydropdata: any = ["true", "false"];
  ISViewDetails: boolean = false;
  EligibleId: number = 0;
  getClientListerr: any = ""
  isDatashowfilter: boolean = false;
  rownum: number;
  printdata: any = [];
  constructor(public datepipe: DatePipe, public global: GlobalComponent,
    public general: GeneralService,  public router: Router, public toastrService: ToastrService, private ref: ChangeDetectorRef,
    public ngxService: NgxUiLoaderService,  public CommonAPI: CommonApiService) {
  }
  ngOnInit(): void {
    this.DataFromList.pageitem = 10;
    this.filterOptions = { type: 'Menu' };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.getEligiblitydiffDetails();

  }
  getEligiblitydiffDetails() {
    let myParams = new URLSearchParams();
    myParams.append("clientId", this.ClientId);
    let url = "api/ClaimProcess/GetEligibilitySummaryDifference?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(myParams, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      data.map(element=>{
        element.isMAEligible = (element.isMAEligible ==true) ? 'Yes' : (element.isMAEligible == null)? null :'No'
        element.spendDown = (element.spendDown ==true) ? 'Yes' : (element.spendDown == null) ? null : 'No'
        element.msho = (element.msho ==true) ? 'Yes' : (element.msho == null) ? null : 'No'
      })
      this.rownum = data.length;
      this.rownum = parseInt(this.rownum.toString())
      this.EDI271Client = data;
      this.printdata = data;
    })
  }
  printalertOpen() {
    document.getElementById('printalertOpen').click();
  }
  printData() {
    document.getElementById('printalertOpen').click();
    var a = window.open('', '', 'height=700, width=700');
    a.document.write('<html>')
    a.document.write('<head><meta name="viewport" content="width=device-width, initial-scale=1"> <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></head>');
    a.document.write('<body ><table class="table table-hover table-bordered table-responsive" style="margin-top: 5px;margin-left: 10px;border:solid #000 !important; border-width:1px 0 0 1px !important;">');
    a.document.write('<thead>');
    a.document.write('<th style="border:solid #000 !important;border-width:0 1px 1px 0 !important;border-top:1px">Name</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Last Eligibility Check</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">MA Eligible</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">PMAP</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Program</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Waiver</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">SpendDown</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">MSHO</th>');
    a.document.write('</thead>');
    a.document.write('<tbody>');
    this.printdata.forEach(element => {
      a.document.write('<tr style="border:solid #000 !important; border-width:1px 0 0 1px !important;">');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + element.clientName + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.lastEligibilityCheck == null ? "" : this.datepipe.transform(element.lastEligibilityCheck, "MM/dd/yyyy")) + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + element.isMAEligible + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.pmap == null ? "" : element.pmap) + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.program == null ? "" : element.program) + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.waiver == null ? "" : element.waiver) + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.spendDown == null ? "" : element.spendDown) + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.msho == null ? "" : element.msho) + '</td>');
      a.document.write('</tr>');
    });
    a.document.write(' </tbody>  </table>');
    a.document.write('</body></html>');
    a.document.close();
    a.print();
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
